(ns ui.editors.simple-filters.model
  (:require
   [malli.core :as m]
   [ui.editors.simple-filters.model-schema :as model-schema]))

;; Filters editor runtime state model (re-frame db).
;; This namespace defines data shape + helpers only.

(def root-path [::state])

(def id-key :id)
(def context-key :context)
(def preference-context-key :preference-context)
(def fields-key :fields)
(def fields-ordered-paths-key :ordered-paths)
(def fields-by-path-key :by-path)
(def po-key :po)
(def pinned-key :pinned)
(def sections-key :sections)
(def filters-key :filters)
(def facets-key :facets)
(def callbacks-key :callbacks)
(def ui-key :ui)

(defn editor-path
  [editor-id]
  (into root-path [editor-id]))

(defn section-path
  [editor-id section-key]
  (into root-path [editor-id section-key]))

(defn context-path
  [editor-id]
  (section-path editor-id context-key))

(defn preference-context-path
  [editor-id]
  (section-path editor-id preference-context-key))

(defn fields-path
  [editor-id]
  (section-path editor-id fields-key))

(defn po-path
  [editor-id]
  (section-path editor-id po-key))

(defn pinned-path
  [editor-id]
  (section-path editor-id pinned-key))

(defn sections-path
  [editor-id]
  (section-path editor-id sections-key))

(defn filters-path
  [editor-id]
  (section-path editor-id filters-key))

(defn facets-path
  [editor-id]
  (section-path editor-id facets-key))

(defn callbacks-path
  [editor-id]
  (section-path editor-id callbacks-key))

(defn ui-path
  [editor-id]
  (section-path editor-id ui-key))

(defn default-runtime
  [{:keys [editor-id view-id entity-type pipeline-id account-id]}]
  {id-key editor-id
   context-key {:entity-type entity-type
                :pipeline-id pipeline-id
                :account-id account-id}
   preference-context-key {:view-id view-id
                           :pipeline-id pipeline-id}
   fields-key {:status :idle
               :error nil
               :search-text ""
               :ordered-paths []
               :by-path {}}
   po-key {:configured-field-paths []
           :visible-field-paths []}
   pinned-key {:field-paths []
               :saving? false
               :error nil}
   sections-key {:po-field-paths []
                 :pinned-field-paths []
                 :runtime-field-paths []}
   filters-key {:by-field-path {}}
   facets-key {:by-field-path {}
               :baseline-by-field-path {}
               :loading-by-field-path {}
               :error-by-field-path {}
               :has-more-by-field-path {}
               :next-offset-by-field-path {}}
   callbacks-key {:load-facets-event nil
                  :on-changed-event nil}
   ui-key {:open-field-path nil
           :field-picker-open? false
           :field-picker-search-text ""
           :option-search-text-by-field {}
           :busy-by-key {}}})

(defn valid-runtime?
  [runtime]
  (m/validate model-schema/model-schema runtime))
